import { Columns, Column, Stack, Button } from 'braid-design-system';
import debounce from 'lodash/debounce';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import type { ListingProduct } from 'src/generated/graphql';

import { usePaymentSubmission } from '../../../hooks/usePaymentSubmission';

import { AcceptedCards } from './components/AcceptedCards/AcceptedCards';
import { CheckoutForm } from './components/CheckoutForm/CheckoutForm';
import { CheckoutFormErrorView } from './components/CheckoutFormErrorView/CheckoutFormErrorView';
import { PaymentHeading } from './components/PaymentHeading/PaymentHeading';
import { EmailAndSearchBoostProductDetails } from './components/ProductDetails/EmailAndSearchBoostProductDetails';

interface EmailAndSearchBoostPaymentScreenProps {
  emailBoostProduct: ListingProduct;
  searchBoostProduct: ListingProduct;
  emailAndSearchBoostProduct: ListingProduct;

  clientId: string;
  listingId: string | null;
}

export const EmailAndSearchBoostPaymentScreen = (
  props: EmailAndSearchBoostPaymentScreenProps,
) => {
  const { pay, loading, error } = usePaymentSubmission();

  const handleSubmit = debounce(async () => {
    await pay({
      clientId: props.clientId,
      listingId: props.listingId,
      selectedProduct: props.emailAndSearchBoostProduct,
      sourceProducts: [props.emailBoostProduct, props.searchBoostProduct],
    });
  }, 500);

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        handleSubmit();
      }}
    >
      <Columns space="medium" collapseBelow="desktop">
        <Column width="2/5">
          <Stack space="large">
            <PaymentHeading />

            {loading ? (
              <CustomLoader />
            ) : (
              <Stack space="medium">
                <AcceptedCards />

                <CheckoutForm />

                <Button type="submit" tone="formAccent">
                  Pay ${props.emailAndSearchBoostProduct.cost / 100} + GST
                </Button>

                {error && <CheckoutFormErrorView error={error} />}
              </Stack>
            )}
          </Stack>
        </Column>

        <Column>
          <Stack space="small">
            <EmailAndSearchBoostProductDetails
              emailBoostProduct={props.emailBoostProduct}
              searchBoostProduct={props.searchBoostProduct}
              emailAndSearchBoostProduct={props.emailAndSearchBoostProduct}
            />
          </Stack>
        </Column>
      </Columns>
    </form>
  );
};
